import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import { FiSearch, FiShoppingCart, FiMenu, FiX } from 'react-icons/fi';
import logo from '../assets/logo.svg'; // Import logo

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const menuRef = useRef(null);
    const hamburgerRef = useRef(null);
    const overlayRef = useRef(null);
    const searchMenuRef = useRef(null);

    const location = useLocation();
    const currentPath = location.pathname;

    const toggleMenu = () => setIsOpen(prevState => !prevState);

    const handleClickOutside = (event) => {
        const target = event.target;

        // Close search menu if clicked outside of it
        if (searchMenuRef.current && !searchMenuRef.current.contains(target)) {
            setIsSearchOpen(false);
        }

        // Close mobile menu if clicked outside of it
        if (
            menuRef.current && !menuRef.current.contains(target) &&
            hamburgerRef.current && !hamburgerRef.current.contains(target) &&
            overlayRef.current && !overlayRef.current.contains(target)
        ) {
            setIsOpen(false);
        }
    };

    const handleMenuItemClick = () => {
        setIsOpen(false); // Menutup menu saat item diklik
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const toggleSearchMenu = () => {
        setIsSearchOpen(prevState => !prevState);
        setIsOpen(false);
    };

    const handleSearchInput = (e) => {
        const searchTerm = e.target.value;

        // Mock search logic - replace with actual API call
        const products = [
            { id: 1, name: "Upcoming Collection", price: "Rp XXX.XXX", img: "https://example.com/tshirt.jpg" },
            { id: 2, name: "Upcoming Collection", price: "Rp XXX.XXX", img: "https://example.com/tshirt.jpg" }
        ];

        if (searchTerm) {
            const filteredProducts = products.filter(product =>
                product.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setSearchResults(filteredProducts);
        } else {
            setSearchResults([]);
        }
    };

    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* Hamburger Menu */}
                <div
                    className="navbar-menu"
                    ref={hamburgerRef}
                    onClick={toggleMenu}
                >
                    {isOpen ? <FiX className="menu-icon" /> : <FiMenu className="menu-icon" />}
                </div>

                {/* Logo */}
                <Link to="/" className="navbar-logo">
                    <img src={logo} alt="Mein Logo" className="navbar-logo-image" />
                </Link>

                {/* Search Bar and Icons */}
                <div className={`navbar-right-section ${isOpen ? 'hidden' : ''}`}>
                    <div className="navbar-icons">
                        <button
                            className={`navbar-icon ${currentPath === '/search' ? 'active' : ''}`}
                            onClick={toggleSearchMenu}
                        >
                            <FiSearch className="icon" />
                        </button>
                        <Link
                            to="/cart"
                            className={`navbar-icon ${currentPath === '/cart' ? 'active' : ''}`}
                        >
                            <FiShoppingCart className="icon" />
                        </Link>
                        {/* <Link
                            to="/profile"
                            className={`navbar-icon ${currentPath === '/profile' ? 'active' : ''}`}
                        >
                            <FiUser className="icon" />
                        </Link> */}
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            <div
                className={`mobile-menu ${isOpen ? 'open' : ''}`}
                ref={menuRef}
                onClick={(e) => e.stopPropagation()} // Mencegah penutupan saat mengklik di dalam menu
            >
                {isOpen && ( // Tampilkan tombol tutup hanya jika menu terbuka
                    <button className="mobile-menu-close" onClick={() => setIsOpen(false)}>
                        <FiX />
                    </button>
                )}
                <ul>
                    <li><Link to="/product" onClick={handleMenuItemClick}>Our Collection</Link></li>
                    {/* <li><Link to="/about" onClick={handleMenuItemClick}>About</Link></li>
                    <li><Link to="/services" onClick={handleMenuItemClick}>Services</Link></li>
                    <li><Link to="/contact" onClick={handleMenuItemClick}>Contact</Link></li> */}
                </ul>
            </div>

            {/* Search Menu */}
            <div
                className={`search-menu ${isSearchOpen ? 'open' : ''}`}
                ref={searchMenuRef}
            >
                <button className="search-menu-close" onClick={toggleSearchMenu}>
                    <FiX />
                </button>
                <div className="search-menu-content">
                    <input
                        type="text"
                        className="search-input"
                        placeholder="Search..."
                        onChange={handleSearchInput}
                    />
                </div>

                {/* Search Results */}
                {searchResults.length > 0 && (
                    <div className="search-results">
                        <h4 className="search-results-title">PRODUCT SUGGESTIONS</h4>
                        <ul className="search-results-list">
                            {searchResults.map(product => (
                                <li key={product.id} className="search-result-item">
                                    <img src={product.img} alt={product.name} className="search-result-image" />
                                    <div className="search-result-details">
                                        <div className="search-result-name">{product.name}</div>
                                        <div className="search-result-price">{product.price}</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>

            {/* Overlay */}
            {isOpen || isSearchOpen ? <div className="overlay show" ref={overlayRef} onClick={() => { setIsOpen(false); setIsSearchOpen(false); }} /> : null}
        </nav>
    );
};

export default Navbar;
